import hookListFactory from "./factory";

export const hookPageList = hookListFactory('pages', { siteKey: 'site_id' })
export const hookSiteList = hookListFactory('sites', null)
export const hookOrganizationList = hookListFactory('organizations', null)
export const hookPathList = hookListFactory('paths', { siteKey: 'siteId' })
export const hookPixelList = hookListFactory('pixels', { siteKey: 'siteId' })
export const hookPublisherList = hookListFactory('publishers', { siteKey: 'site_id' })
export const hookSubIdList = hookListFactory('subids', null)
export const hookSiteFieldsList = hookListFactory('site/fields', { siteKey: 'siteId' })
export const hookDatasourceList = hookListFactory('datasources', { siteKey: 'siteId' })
export const hookAllocationList = hookListFactory('allocations', { siteKey: 'siteId' })
export const hookFormList = hookListFactory('forms', { siteKey: 'site_id' })
export const hookOfferList = hookListFactory('offers', { siteKey: 'site_id' })
export const hookIntegrationList = hookListFactory('integrations', { siteKey: 'site_id' })
export const hookPostList = hookListFactory('cms/posts', { siteKey: 'site_id' })
export const hookCustomFieldsList = hookListFactory('customFields', { siteKey: 'siteId' })
export const hookCMSBuilderBlockList = hookListFactory('cms-builder/blocks', { siteKey: 'siteId' })
export const hookOrganizationUserList = hookListFactory('organization/users', null)
export const hookRewardList = hookListFactory('rewards', { siteKey: 'site_id' })
export const hookRewardStepList = hookListFactory('reward-steps', { siteKey: 'site_id' })
export const hookUserProfileList = hookListFactory('user-profiles', { siteKey: 'siteId' })
export const hookRouteList = hookListFactory('cms/routes', { siteKey: 'siteId' })
export const hookTagList = hookListFactory('cms/tags', { siteKey: 'siteId' })
export const hookMetaFieldList = hookListFactory('meta-fields', { siteKey: 'siteId' })

export * from "./factory";
